import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, bootstrapped } = useAuth();
  if (!bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <div className="text-forest font-serif text-2xl animate-pulse">Noa</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
